import RelayIcon from '@/components/RelayIcon'
import { useResolvedHardcodedFeed } from '@/hooks/useResolvedHardcodedFeed'
import type { THardcodedFeed } from '@/types/universe'

export default function HardcodedFeedTitle({ item }: { item: THardcodedFeed }) {
  const { name, icon } = useResolvedHardcodedFeed(item)

  return (
    <>
      {icon ? (
        <img src={icon} className="w-6 h-6 object-cover object-center rounded shrink-0" alt="" />
      ) : (
        <RelayIcon iconSize={14} className="w-6 h-6 shrink-0" />
      )}
      <div className="text-lg font-semibold truncate">{name}</div>
    </>
  )
}
